import File from '@uni/file';
import { isAndroid, isStrictWechatMiniProgram } from '../utils';
import { UPLOAD_THROTTLE } from './utils';
function request(obj) {
    const task = File.upload({
        url: obj.action,
        formData: obj.data,
        filePath: obj.file,
        withCredentials: obj.withCredentials,
        fileName: obj.filename,
        fileType: obj.fileType,
        header: obj.headers,
        success: (res) => obj.onSuccess(res),
        fail: (e) => obj.onError(e),
    });
    const skipTaskProgressUpdate = isAndroid && isStrictWechatMiniProgram;
    if (task && task.onProgressUpdate && !skipTaskProgressUpdate) {
        task.onProgressUpdate(({ progress }) => {
            obj.onProgress({
                percent: progress,
            });
        });
    }
    else {
        let percent = 10;
        const timer = setInterval(() => {
            if (percent < 90) {
                percent += 10;
                obj.onProgress({
                    percent,
                });
            }
            else {
                clearInterval(timer);
            }
        }, UPLOAD_THROTTLE);
    }
    return {
        abort: () => {
            if (task && task.abort) {
                task.abort();
            }
        },
    };
}
export default request;
